import NewBadge from './NewBadge.component';

export default NewBadge;
